import { AbilitySubject } from '../auth/authorization/subject.interface';
import { NotificationSeverity } from '../custom-notification/custom-notification.interface';

export enum NotificationType {
  custom = 'custom',
  system = 'system',
  ticket = 'ticket',
  olt = 'olt',
}

export const autoGeneratedNotificationTypes = [
  NotificationType.system,
  NotificationType.ticket,
  NotificationType.olt,
];

export interface INotification {
  id?: string;
  text: string;
  kind: AbilitySubject;
  severity: NotificationSeverity;
  message?: string;
  url?: string;
  read?: boolean;
  type?: NotificationType;
}

export function getIconBySeverity(severity: NotificationSeverity | string) {
  switch (severity) {
    case NotificationSeverity.info:
      return 'pi pi-info-circle text-primary-500';
    case NotificationSeverity.warn:
      return 'pi pi-exclamation-circle text-warn-500';
    case NotificationSeverity.danger:
      return 'pi pi-times-circle text-danger-500';
    default:
      return 'pi pi-info-circle';
  }
}
